var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll"
        }
      ],
      ref: "menu",
      staticClass: "page-menu",
      class: { "menu-hidden": _vm.menuHidden, opened: _vm.menuOpened }
    },
    [
      _vm._t("before"),
      _vm._l(_vm.elements, function(block, i) {
        return (i === 1
        ? _vm.menuOpened
        : true)
          ? _c(
              "div",
              { class: "menu__" + _vm.blockNames[i] },
              [
                _vm._l(block, function(el) {
                  return [
                    (_vm.data[el.fullName] &&
                    _vm.data[el.fullName].visible !== undefined
                    ? _vm.data[el.fullName].visible
                    : true)
                      ? _c(
                          el.type,
                          _vm._b(
                            {
                              tag: "div",
                              class: [
                                _vm.blockNames[i] + "__" + el.name,
                                "menu__" + el.name,
                                _vm.classes[el.fullName],
                                el.num ? el.name + "_" + el.num : false,
                                {
                                  changed: _vm.isChangedButton(el),
                                  opened:
                                    _vm.isChangedButton(el) && _vm.menuOpened
                                }
                              ],
                              attrs: {
                                click:
                                  el.name === "button" ||
                                  (el.type === "linker" && _vm.menuOpened)
                                    ? _vm.toggleMenu
                                    : null
                              }
                            },
                            "div",
                            Object.assign({}, el.props, _vm.data[el.fullName]),
                            false
                          ),
                          [
                            el.name !== "items"
                              ? _vm._t(
                                  el.fullName,
                                  null,
                                  _vm._d({}, [
                                    el.fullName,
                                    _vm.data[el.fullName]
                                  ])
                                )
                              : _vm._l(_vm.items, function(item, j) {
                                  return [
                                    _c("pass", {
                                      attrs: {
                                        a_item: _vm.getItem(item, j, i === 1)
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function(ref) {
                                              var a_item = ref.a_item
                                              return [
                                                _vm._t(
                                                  el.fullName,
                                                  [
                                                    _c(
                                                      "linker",
                                                      _vm._b(
                                                        {
                                                          staticClass:
                                                            "items__item",
                                                          class: _vm.getItemClass(
                                                            item,
                                                            j,
                                                            i
                                                          ),
                                                          attrs: {
                                                            goalName: _vm._getItemGoal(
                                                              j
                                                            )
                                                          },
                                                          nativeOn: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              _vm.menuOpened
                                                                ? _vm.toggleMenu()
                                                                : false
                                                            }
                                                          }
                                                        },
                                                        "linker",
                                                        a_item,
                                                        false
                                                      )
                                                    )
                                                  ],
                                                  { item: _vm.getItem(item) }
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ]
                                })
                          ],
                          2
                        )
                      : _vm._e()
                  ]
                })
              ],
              2
            )
          : _vm._e()
      }),
      _vm._t("after")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }